import api from "./base-api"


const chargeTemplateApi = api.injectEndpoints({
    endpoints: (build) => ({
        getAllChargeTemplates: build.query({
            query: (game) => `v2/chargeTemplate/${game}`,
            providesTags: ["ChargeTemplates"]
        }),
        createChargeTemplate: build.mutation({
            query: (data) => ({
                url: `v2/chargeTemplate`,
                body: data,
                method: "POST"
            }),
            invalidatesTags: ['ChargeTemplates']
        }),
        deleteChargeTemplate: build.mutation({
            query: (data) => ({
                url: `v2/chargeTemplate`,
                body: data,
                method: "DELETE"
            }),
            invalidatesTags: ['ChargeTemplates']
        })
    })
})

export const {
    useGetAllChargeTemplatesQuery,
    useCreateChargeTemplateMutation,
    useDeleteChargeTemplateMutation,
} = chargeTemplateApi